import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiPopupHeaderBar from "../components/PiPopupHeaderBar";
import { InteractionType } from "../../../models/interactions/Interaction";
import ClickIndicatorPreviewBody from "./ClickIndicatorPreviewBody";

export default function ClickIndicatorPreview() {
  return (
    <PiPopupWindowPreview
      size="medium"
      body={<ClickIndicatorPreviewBody />}
      header={<PiPopupHeaderBar interactionType={InteractionType.ClickIndicator} title="Click Indicator" />}
    />
  );
}
